import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';

const handleSum = num => {
    const arr = [];

    for (let i = 0; i < 9; i++) {
        arr.push(num % 10);

        num = Math.floor(num / 10);
    }

    return arr.reverse();
};

class HMap extends PureComponent {
    static propTypes = {
        data: PropTypes.array,
        updateTime: PropTypes.string,
    };

    echarts = null;
    map = null;

    nameMap = {};

    async componentDidMount() {
        // 引入 ECharts 主模块
        this.echarts = await import('echarts/lib/echarts');

        // 引入世界地图
        await import('echarts/map/js/world');

        this.map = this.echarts.init(document.getElementById('hworld'));
        this.mapRender();
    }

    mapRender = async () => {
        this.nameMap = await import('../../map/name/USA');

        this.nameMap = this.nameMap.default;

        let countryMap = await import('../../map/json/USA');

        countryMap = countryMap.default;

        this.echarts.registerMap('worldCity', countryMap, {
            Alaska: {
                left: -131,
                top: 27,
                width: 15,
            },
            Hawaii: {
                left: -110,
                top: 24,
                width: 7,
            },
        });

        const cityArr = countryMap.features.map(item => this.nameMap[item.properties.name] || '');

        const mapData = cityArr.map(item => this.getAreaData(item));

        const extra = {
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            layoutCenter: ['47%', '38%'],
            layoutSize: '120%',
        };

        const worldSeries = [
            {
                name: '世界',
                type: 'map',
                mapType: 'worldCity',
                ...extra,
                itemStyle: {
                    normal: {
                        borderColor: '#E2B2B2', // 边框颜色
                        borderWidth: 0.5, // 边框线宽
                    },
                },
                label: {
                    show: false,
                },
                data: mapData,
                nameMap: this.nameMap,
            },
        ];

        const option = {
            series: worldSeries,
        };

        this.map.setOption(option);
    };

    getAreaData = name => {
        const { data } = this.props;

        let areaObj = {
            name,
            itemStyle: {
                normal: {
                    areaColor: '#DDDDDD',
                },
            },
            num: [0, 0, 0],
        };

        data.every(item => {
            if (name.indexOf(item.name) === 0) {
                const bidenNum = item.bidenNum;
                const trumpNum = item.trumpNum;
                const bidenSum = item.bidenSum;
                const trumpSum = item.trumpSum;

                const status = item.status;

                areaObj = {
                    ...areaObj,
                    itemStyle: {
                        normal: {
                            areaColor: this.getColor({
                                bidenNum,
                                trumpNum,
                                bidenSum,
                                trumpSum,
                                status,
                            }),
                        },
                    },
                };

                return false;
            }

            return true;
        });

        return areaObj;
    };

    getColor = ({ bidenNum, trumpNum, bidenSum, trumpSum, status }) => {
        if (status === '未开始') return '#DDDDDD';

        if (!bidenNum && !trumpNum) {
            if (bidenSum > trumpSum) return status === '已结束' ? '#0257A0' : '#6a94b8';
            if (trumpSum > bidenSum) return status === '已结束' ? '#CA1D2A' : '#e68888';
        } else {
            if (bidenNum > trumpNum) return status === '已结束' ? '#0257A0' : '#6a94b8';
            if (trumpNum > bidenNum) return status === '已结束' ? '#CA1D2A' : '#e68888';
        }

        return '#DDDDDD';
    };

    render() {
        const { data, updateTime } = this.props;

        const {
            bidenNum,
            trumpNum,
            bidenSum,
            trumpSum,
            _bidenRate,
            _trumpRate,
            _bidenSumRate,
            _trumpSumRate,
        } = data[0];

        const bidenSumArr = handleSum(bidenSum);
        const trumpSumArr = handleSum(trumpSum);

        return (
            <div className={styles.map_box}>
                <div className={styles.progress_box}>
                    <img
                        crossOrigin="Anonymous"
                        src="https://x0.ifengimg.com/ucms/2024_44/230239698AB273061E931AD64A67E61FA8F6535F_size12_w730_h117.png"
                    />
                    <div className={styles.bar}>
                        <span style={{ width: `${_trumpRate}%`, zIndex: trumpNum >= 270 ? 9 : 0 }} />
                        <span style={{ width: `${_bidenRate}%`, zIndex: bidenNum >= 270 ? 9 : 0 }} />
                    </div>
                    <div className={styles.icon}>
                        <img
                            crossOrigin="Anonymous"
                            src="https://x0.ifengimg.com/ucms/2020_44/FA30A7D2F50E044FBD3CAB1B1234050439F5F7E3_w160_h160.png"
                            style={{ left: `${_trumpRate}%`, zIndex: trumpNum >= 270 ? 10 : 0 }}
                        />
                        <img
                            crossOrigin="Anonymous"
                            src="https://x0.ifengimg.com/ucms/2020_44/1333B1205A75A56F866BF0161FEDBFCDADFAC7C5_w164_h160.png"
                            style={{ right: `${_bidenRate}%`, zIndex: bidenNum >= 270 ? 10 : 0 }}
                        />
                    </div>
                </div>
                <div className={styles.num_box}>
                    <div className={styles.trump_box}>
                        <img
                            crossOrigin="Anonymous"
                            src="https://x0.ifengimg.com/ucms/2020_45/86F7F34EBAB966FE93E4025B5689DAF09EDEC693_w832_h624.png"
                        />
                        <div className={styles.trump}>
                            <div className={styles.num}>
                                <span>
                                    <img
                                        crossOrigin="Anonymous"
                                        src="https://x0.ifengimg.com/ucms/2020_44/76993C3AF2949E4A8BF072F1C61A5B1A6CBDCD3E_w376_h456.png"
                                    />
                                    <span>{Math.floor(trumpNum / 100)}</span>
                                </span>
                                <span>
                                    <img
                                        crossOrigin="Anonymous"
                                        src="https://x0.ifengimg.com/ucms/2020_44/76993C3AF2949E4A8BF072F1C61A5B1A6CBDCD3E_w376_h456.png"
                                    />
                                    <span>{Math.floor((trumpNum % 100) / 10)}</span>
                                </span>
                                <span>
                                    <img
                                        crossOrigin="Anonymous"
                                        src="https://x0.ifengimg.com/ucms/2020_44/76993C3AF2949E4A8BF072F1C61A5B1A6CBDCD3E_w376_h456.png"
                                    />
                                    <span>{Math.floor(trumpNum % 10)}</span>
                                </span>
                            </div>
                            <div className={styles.br} />
                            <div className={styles.sum}>
                                <span>{`${trumpSumArr[0]}${trumpSumArr[1]}${trumpSumArr[2]}`}</span>
                                <span>{`${trumpSumArr[3]}${trumpSumArr[4]}${trumpSumArr[5]}`}</span>
                                <span>{`${trumpSumArr[6]}${trumpSumArr[7]}${trumpSumArr[8]}`}</span>
                                <span />
                                <span>票</span>
                            </div>
                            <div className={styles.br} />
                            <div className={styles.rate}>
                                <img
                                    crossOrigin="Anonymous"
                                    src="https://x0.ifengimg.com/ucms/2020_44/CF80933378EF0ADCD4F61E7D941C1CBE563633EC_w40_h32.png"
                                />
                                <span>(选民选票)</span>
                                <span>{`${_trumpSumRate}%`}</span>
                            </div>
                        </div>
                    </div>
                    <div className={styles.biden_box}>
                        <img
                            crossOrigin="Anonymous"
                            src="https://x0.ifengimg.com/ucms/2020_45/86F7F34EBAB966FE93E4025B5689DAF09EDEC693_w832_h624.png"
                        />
                        <div className={styles.biden}>
                            <div className={styles.num}>
                                <span>
                                    <img
                                        crossOrigin="Anonymous"
                                        src="https://x0.ifengimg.com/ucms/2020_44/76993C3AF2949E4A8BF072F1C61A5B1A6CBDCD3E_w376_h456.png"
                                    />
                                    <span>{Math.floor(bidenNum / 100)}</span>
                                </span>
                                <span>
                                    <img
                                        crossOrigin="Anonymous"
                                        src="https://x0.ifengimg.com/ucms/2020_44/76993C3AF2949E4A8BF072F1C61A5B1A6CBDCD3E_w376_h456.png"
                                    />
                                    <span>{Math.floor((bidenNum % 100) / 10)}</span>
                                </span>
                                <span>
                                    <img
                                        crossOrigin="Anonymous"
                                        src="https://x0.ifengimg.com/ucms/2020_44/76993C3AF2949E4A8BF072F1C61A5B1A6CBDCD3E_w376_h456.png"
                                    />
                                    <span>{Math.floor(bidenNum % 10)}</span>
                                </span>
                            </div>
                            <div className={styles.br} />
                            <div className={styles.sum}>
                                <span>{`${bidenSumArr[0]}${bidenSumArr[1]}${bidenSumArr[2]}`}</span>
                                <span>{`${bidenSumArr[3]}${bidenSumArr[4]}${bidenSumArr[5]}`}</span>
                                <span>{`${bidenSumArr[6]}${bidenSumArr[7]}${bidenSumArr[8]}`}</span>
                                <span />
                                <span>票</span>
                            </div>
                            <div className={styles.br} />
                            <div className={styles.rate}>
                                <img
                                    crossOrigin="Anonymous"
                                    src="https://x0.ifengimg.com/ucms/2020_44/20E994A5F13DB66FC56F1C2BC94113755184784B_w40_h32.png"
                                />
                                <span>(选民选票)</span>
                                <span>{`${_bidenSumRate}%`}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={styles.title}>
                    <span>选举地图</span>
                    <span>
                        <span>数据截至</span>
                        {updateTime}
                    </span>
                </div>
                <div className={styles.box}>
                    <img src="https://x0.ifengimg.com/ucms/2020_45/F0FC58928BEA4FBC9A1F772539F7A7A617DD01CE_w1680_h1332.png" />
                    <div id="hworld" className={styles.map} />
                    <img
                        src="https://x0.ifengimg.com/ucms/2024_45/89C0136F52DEFBAA1A0051B8A3247EEAEB9F938A_size23_w705_h234.png"
                        className={styles.bar_box}
                    />
                </div>
            </div>
        );
    }
}

export default errorBoundary(HMap);
